<template>
	<div>
		<div class="custom-control custom-radio remove-padding-lr m-t-8"
		     v-for="radio in radios.data" v-if="!v2">
			<input class="custom-control-input"
			       type="radio"
			       :id="radio.id"
			       :name="radios.name"
			       :value="radio.orderBy"
			       :checked="radio.checked"
			       @click="selected(radio)"
			/>
			<label class="custom-control-label"
			       :for="radio.id"
			       :class="{'text-bold': radio.titleBold}"
			>
				{{ radio.title }}
			</label>
		</div>

		<div class="custom-control custom-radio remove-padding-lr m-t-8"
		     v-for="radio in radios" v-if="v2">
			<input class="custom-control-input"
			       v-model="selectedRadioData"
			       type="radio"
			       :id="radio.id"
			       :name="radios.name"
			       :value="radio.value"
			       @click="selected(radio)"
			/>
			<label class="custom-control-label"
			       :for="radio.id"
			       :class="{'text-bold': radio.titleBold}"
			>
				{{ radio.label }}
			</label>
		</div>
	</div>
</template>

<script>

// radio: {
// 	name: String,
// 	id: String,
// 	value: String,
// 	title: String,
// 	checked: Boolean,
// 	titleBold: Boolean,
// },

export default {
	name: "SOInputRadio",
	props: {
		radios: Array,
		v2:Boolean,
		selectedRadio: String,
	},
	data() {
		return {
			selectedRadioData: "",
		}
	},
	watch: {
		radios: {
			handler: function (v) {
				this.radios = v
			},
			deep: true,
		},
		selectedRadio: {
			handler: function (v) {
				this.selectedRadioData = v
			}
		}
	},
	mounted() {
		this.selectedRadioData = this.selectedRadio
	},
	methods: {
		selected(obj) {
			this.$emit("selected", obj)
		}
	},
}
</script>

<style scoped>
.text-bold {
	font-weight: bold;
}
</style>